<template>
    <v-app id="app" :class="{ 'app-transparent': $route.name === 'LiveData' }">
        <div v-if="$route.name === 'LiveData'">
            <router-view />
        </div>
        <v-container v-else class="bg mx-0 px-0" :class="$vuetify.breakpoint.mobile ? 'bg--mobile mt-0 pt-0' : 'my-0 py-0'" fluid>
            <v-banner
                v-if="device !== 'web'"
                height="150px"
                color="white"
                class="my-0 py-0 safe-top-banner"
                sticky
                style="z-index: 1000000;"
            >
                <v-row justify="center" align="center" class="py-0 my-0">
                    <v-col cols="12" align="center" class="py-0 my-0">
                        <span>
                            <v-icon style="cursor: pointer;" @click="device='web'">mdi-close</v-icon>
                        </span>
                        <span class="ml-5">Για την καλύτερη εμπειρία, κατεβάστε την εφαρμογή μας για κινητά!</span>
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-img
                            v-if="device === 'android'"
                            height="53px"
                            width="160px"
                            style="cursor: pointer;"
                            :src="require('@/assets/google_play.png')"
                            @click="openSocial('google_play')"
                        />
                        <v-img
                            v-else-if="device === 'ios'"
                            height="53px"
                            width="151px"
                            style="cursor: pointer;"
                            :src="require('@/assets/app_store.png')"
                            @click="openSocial('app_store')"
                        />
                    </v-col>
                </v-row>
            </v-banner>
            <section-title v-if="$vuetify.breakpoint.mobile" :title="typeof $route.meta === 'string' ? $route.meta : '' " :class="[$vuetify.breakpoint.mobile && $route.name !== 'FacebookPostMatch' ? 'mb-10' : '', 'safe-top-banner']" />
            <nav-bar v-if="$route.name !== 'FacebookPostMatch'" :class="$vuetify.breakpoint.mobile ? '' : 'py-10'" />
            <v-row no-gutters :class="$vuetify.breakpoint.mobile || $route.name === 'FacebookPostMatch' ? '' : 'px-0'" class="py-0 my-0">
                <!-- <aegean-ball v-if="!($route.name === 'Team' || $route.name === 'Match')"/> -->
                <v-col cols="12" class="py-0 my-0">
                    <router-view />
                </v-col>
            </v-row>
        </v-container>
        <custom-footer v-if="!$vuetify.breakpoint.mobile && $route.name !== 'LiveData'" />
        <!-- back to the top: a card of the site (white, soft shadow, orange arrow), black + orange on hover -->
        <transition name="to-top">
            <button
                v-show="fab"
                v-scroll="onScroll"
                type="button"
                class="to-top"
                :class="{ 'to-top--mobile': $vuetify.breakpoint.mobile }"
                aria-label="Στην αρχή της σελίδας"
                title="Στην αρχή της σελίδας"
                @click="toTop"
            >
                <v-icon class="to-top__icon custom-orange-text">mdi-arrow-up</v-icon>
            </button>
        </transition>
    </v-app>
</template>

<script>
    import NavBar from '@/components/NavBar.vue'
    import CustomFooter from '@/components/Footer.vue'
    // import AegeanBall from './components/AegeanBall.vue'
    import SectionTitle from '@/components/Title'
    import pushService from '@/services/push'
    import { Capacitor } from '@capacitor/core'
    export default {
        name: 'App',
        components: {
            NavBar,
            SectionTitle,
            CustomFooter
        },
        data() {
            return {
                fab: false,
                device: 'web' // Default to web, will be updated in mounted()
            }
        },
        watch: {
            $route() {
                document.title = `BIG | ${this.$route.meta}`
                this.syncTransparentBody()
            }
        },
        mounted() {
            this.syncTransparentBody()
            // Only prompt mobile browser visitors; inside the native app there's nothing to download
            if (this.isNativeApp()) {
                document.documentElement.classList.add('native-app')
            } else {
                this.device = this.detectMobileOS()
            }
        },
        created() {
            this.ensureConfig()
            if (this.$store.getters.getNotifications) {
                pushService.init()
                this.$store.dispatch('ensureNewsTopic')
            }
        },
        methods: {
            ensureConfig() {
                return this.$store.dispatch('ensureConfig')
            },
            isNativeApp() {
                return Capacitor.isNativePlatform()
            },
            detectMobileOS() {
                const ua = navigator.userAgent || ''
                if (/android/i.test(ua)) return 'android'
                // iPadOS 13+ reports itself as a Mac, so also check for touch support
                if (/iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'ios'
                return 'web'
            },
            openSocial(social) {
                if (social === 'google_play') {
                    window.open('https://play.google.com/store/apps/details?id=com.vue.big.app', '_blank')
                } else if (social === 'app_store') {
                    window.open('https://apps.apple.com/us/app/b-i-g/id6748522198', '_blank')
                }
            },
            onScroll(e) {
                if (typeof window === 'undefined') return
                const top = window.pageYOffset || e.target.scrollTop || 0
                this.fab = top > 20
            },
            toTop() {
                this.$vuetify.goTo(0)
            },
            syncTransparentBody() {
                const live = this.$route?.name === 'LiveData'
                document.body.classList.toggle('body-transparent', !!live)
            }
        }
    }
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Mansalva&display=swap');
@import url('https://fonts.googleapis.com/css?family=Ubuntu&display=swap');

.v-slide-group__prev {
    display: none !important;
}

.v-tab--active {
    background: linear-gradient(90deg, #ef4444 0%, #ff7133 70%, orange 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.custom-orange {
    background: linear-gradient(90deg, #ef4444 0%, #ff7133 50%, orange 100%);
}

/* Shows the whole image (contain) and fills the empty space with a blurred copy of it */
.media-blur-backdrop {
    position: absolute;
    inset: -30px;
    background-size: cover;
    background-position: center;
    filter: blur(24px) brightness(0.55);
    transform: scale(1.1);
}

.media-blur-backdrop + .v-image {
    position: relative;
    z-index: 1;
}

.custom-orange-text {
    background-image: linear-gradient(90deg, #ef4444 0%, #ff7133 70%, orange 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* The native apps draw edge-to-edge (viewport-fit=cover): keep the header's content below the
   status bar / notch, while its white background still reaches the top of the screen.
   --safe-area-inset-top is injected by Capacitor on Android, where env() can report 0.
   #app raises specificity above Vuetify's `.py-0 { padding-top: 0 !important }` on the same element */
#app .safe-top-banner {
    padding-top: max(env(safe-area-inset-top), var(--safe-area-inset-top, env(safe-area-inset-top))) !important;
    background-color: white;
}

/* Same for the mobile bottom bar: grow it by the home indicator / rounded corner area and keep its
   content above it. !important beats the inline 60px height Vuetify sets on the app bar */
#app .safe-bottom-bar {
    --safe-bottom-inset: max(env(safe-area-inset-bottom), var(--safe-area-inset-bottom, env(safe-area-inset-bottom)));

    height: calc(60px + var(--safe-bottom-inset)) !important;
    padding-bottom: var(--safe-bottom-inset);
}

/* No elastic overscroll in the apps: on iOS it drags the fixed header and bottom bar along.
   The website keeps it, so mobile browsers still have pull-to-refresh */
html.native-app,
html.native-app body {
    overscroll-behavior: none;
}

#app {
    font-family: Mansalva, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    position: relative;
    min-height: 100vh;
}

#app::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: -1;
    pointer-events: none;
    background: #dddddf url('assets/dunk-bg-2.jpg') center top / cover no-repeat;
}

.app-transparent,
.app-transparent .v-application,
.app-transparent .v-application--wrap {
    background: transparent !important;
    background-color: transparent !important;
}

.app-transparent::before {
    opacity: 0;
}

#app,
#app .v-application,
#app .v-application--wrap {
    background: transparent !important;
    background-color: transparent !important;
}

/* The page grows to fill the screen, so the footer sits at the bottom of short pages.
   (min-height: 100% used to resolve against the wrapper that also holds the footer,
   which left a footer-sized empty space above it on every page) */
.bg {
    flex: 1 0 auto;
    width: 100%;
    height: auto;
    background: transparent;
}

/* phones: only the room the fixed bottom bar covers, plus a little air */
.bg--mobile {
    /* a variable, because the CSS minifier cannot parse max() inside calc() */
    --safe-bottom: max(env(safe-area-inset-bottom), var(--safe-area-inset-bottom, env(safe-area-inset-bottom)));

    padding-bottom: calc(84px + var(--safe-bottom)) !important;
}

@media only screen and (max-width: 1000px) {
    #app::before {
        background-position: center top;
        background-size: 100% auto;
    }
}

.v-data-table {
    font-family: Ubuntu, Arial, sans-serif !important;
    font-weight: 400;
}

/* Moved from NavBar (it was unscoped there, so it already applied app-wide): no tinted text on active list items */
.v-list-item--active {
    color: transparent !important;
}

/* Transparent carousel arrows (used by the BIG Moments carousel) */
.v-window__next,
.v-window__prev {
    background: rgba(0, 0, 0, 0);
    margin: 0 -5px;
}

.v-select__selection--comma {
    font-weight: 600 !important;
}

.v-select,
.v-text-field,
.v-list-item {
    font-family: Ubuntu, Arial, sans-serif !important;
    font-weight: 600;
}

.v-list-item__title {
    white-space: normal !important;
}

.v-tooltip__content.ts-tooltip-surface {
    background: #fff !important;
    background-color: #fff !important;
    opacity: 1 !important;
    color: #111 !important;
    border: 1px solid #d7dbe3;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    width: min(560px, calc(100vw - 24px)) !important;
    min-width: min(560px, calc(100vw - 24px));
    max-width: min(560px, calc(100vw - 24px)) !important;
    white-space: normal !important;
    overflow-wrap: break-word;
    word-break: normal;
}

.v-tooltip__content {
    max-width: calc(100vw - 24px) !important;
}

.v-data-table .v-data-table__wrapper {
    overflow: auto;
}

.v-data-table .v-data-table__wrapper table > tbody > tr > td:nth-child(1) {
    position: sticky !important;
    left: 0;
    background: #fff !important;
    background-color: #fff !important;
    z-index: 2;
}

.v-data-table .v-data-table__wrapper table > thead > tr > th:nth-child(1) {
    position: sticky !important;
    left: 0;
    background: #fff !important;
    background-color: #fff !important;
    z-index: 3;
}

/* Unified hover effect for all Vuetify data tables (desktop/laptop only) */
@media only screen and (min-width: 1001px) {
    .v-data-table:not(.no-global-table-hover) .v-data-table__wrapper table tbody tr {
        position: relative;
    }

    .v-data-table:not(.no-global-table-hover) .v-data-table__wrapper table tbody tr:hover {
        cursor: pointer;
    }

    .v-data-table:not(.no-global-table-hover) .v-data-table__wrapper table tbody tr::after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(90deg, #ef4444 0%, #ff7133 70%, #ffa500 100%);
        opacity: 0;
        transition: opacity 0.2s ease;
        pointer-events: none;
        z-index: 0;
    }

    .v-data-table:not(.no-global-table-hover) .v-data-table__wrapper table tbody tr:hover::after {
        opacity: 1;
    }

    .v-data-table:not(.no-global-table-hover) .v-data-table__wrapper table tbody tr:hover td {
        background: transparent !important;
        color: #fff !important;
        position: relative;
        z-index: 1;
    }

    .v-data-table:not(.no-global-table-hover) .v-data-table__wrapper table tbody tr:hover td .v-icon,
    .v-data-table:not(.no-global-table-hover) .v-data-table__wrapper table tbody tr:hover td .custom-orange-text,
    .v-data-table:not(.no-global-table-hover) .v-data-table__wrapper table tbody tr:hover td span {
        color: #fff !important;
        -webkit-text-fill-color: #fff !important;
    }
}

thead {
    white-space: nowrap;
}

.secondary-font {
    font-family: Ubuntu, Arial, sans-serif !important;
    font-weight: 700;
}

/* width */
::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:horizontal {
    border-radius: 10px;
}

.clickable {
    cursor: pointer !important;
}

/* Also clear page background when LiveData */
.body-transparent {
    background: transparent !important;
    background-color: transparent !important;
}

/* ---------- Back to top ---------- */
.to-top {
    position: fixed;
    right: 25px;
    bottom: 100px;
    z-index: 14;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.16);
    transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

/* the orange line on top, as on the match cards */
.to-top::before {
    content: '';
    position: absolute;
    top: -1px;
    left: 10px;
    right: 10px;
    height: 3px;
    border-radius: 0 0 3px 3px;
    background: linear-gradient(90deg, #ef4444, #ff7133, orange);
}

.to-top:hover {
    background: #0d0d0f;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.24);
    transform: translateY(-2px);
}

.to-top__icon {
    font-size: 26px !important;
}

/* above the bottom tab bar of the app */
.to-top--mobile {
    right: 12px;
    bottom: calc(84px + env(safe-area-inset-bottom, 0px));
    width: 42px;
    height: 42px;
    border-radius: 12px;
}

.to-top--mobile .to-top__icon {
    font-size: 22px !important;
}

.to-top-enter-active,
.to-top-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.to-top-enter,
.to-top-leave-to {
    opacity: 0;
    transform: translateY(10px);
}
</style>
